import type { AnalyticsWebClient } from '@jira/platform__observability-product-analytics-web-client-types';

export const getInitializedAnalyticsWebClient = (): AnalyticsWebClient => {
	// oxlint-disable-next-line typescript/no-non-null-assertion
	return window.analyticsWebClient!; // eslint-disable-line jira/jira-ssr/no-unchecked-globals-usage
};
